export default `
@import url('https://use.typekit.net/ucp6oqc.css');

:root {
    --success-color: #60CDB2;
    --primary-color: #182C4C;
    --finway-dark: #231c5b;
    --finway-light: #60CDB2;
}

.content{
    font-family: proxima-nova, sans-serif;
    color: #606C7E;
    border-radius: 4px;
    box-shadow: none;
    padding: 0;
    margin: 0;
    max-width: none;
}

h2 {
    font-size: 16px;
}

/* To define the bottom border of input fields */
input {
    font-family: proxima-nova, sans-serif;
    border-bottom: 1px solid #c6d1d9;
}

/* To move the field prompts upwards so it's above the field */
.input-field span, .radio-group span {
    position: relative;
    font-size: 14px;
    bottom: 55px;
}



/* To remove the * ::after the field, and move it ::before */
.fields-list .required::after {
    content: "";
}
.fields-list .required::before {
    display: inline-block;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
}

/* To increase the vertical space between each fields */
.fields-list.fields-list-two-columns .input-field {
    margin-bottom: 15px;
    margin-top: 15px;
}

/* To remove all uppercase texts */
.uppercase {
    letter-spacing: normal;
    text-transform: none;
}

/* To reduce the height of the upload (drag drop) input */
.upload-payment-item .upload-item {
    height: 100px;
}
.upload-item .drag-drop {
    height: 85px;
}

/* add space between the subtitle and the form */
.subtitle {
    margin-bottom: 90px;
}

/* To avoid the dropdown in the upload box overlapping with the "cancel" button */
.upload-item .doctype-selector select {
    width: 80%;
}

p  {
    color: #182C4C;
    line-height: 1.36;
    margin: 15px 0
}

ul li {
    color: var(--primary-color);
}

a {
    color: var(--finway-dark);
}

a:hover {
    color: var(--primary-color);
    border-bottom: none;
}

.upload-payment-item .upload-item {
    border-radius: 2px;
    border: 1px dashed #d9d9d9;
    box-shadow: none;
}

.datetime-edit-field {
    font-family: proxima-nova, sans-serif;
}

.upload-item i.upload-icon {
    font-size: 20px;
}

.upload-item h4 {
    font-weight: normal;
    font-size: 12px;
}

.upload-item .doctype-selector button {
    height: auto;
}

.upload-item .remove {
    background: var(--finway-dark)
}

.upload-item .remove:hover {
    background: var(--finway-light)
}

button.submit,
button.submit:active:not(:disabled), 
button.submit:hover:not(:disabled):not(.disabled):not(:active), 
button[type="submit"]:active:not(:disabled), 
button[type="submit"]:hover:not(:disabled):not(.disabled):not(:active) {
    text-transform: none !important;
    font-weight: normal !important;
    background-image: none !important;
    background-color: var(--finway-dark) !important;
    border-radius: 4px !important;
    letter-spacing: normal !important;
    font-size: 15px;
    padding: 5px 10px !important;
    font-size: 15px;
    height: 34px;
}

button {
    text-transform: none !important;
    font-weight: normal !important;
    background-image: none !important;
    background-color: var(--finway-dark) !important;
    border-radius: 4px !important;
    letter-spacing: normal !important;
    font-size: 15px;
    padding: 5px 10px !important;
    font-size: 15px;
    height: 34px;
    color: var(--white-color);
}

.arrow {
    display: none !important;
}

/* Remove the "Continue on Mobile" button */
.mobile-button {
    display: none;
}

/* Remove the SumSub logo */
.sumsub-logo {
    display: none;
}

/* Styling for the list of UBOs (page 2) */
.payment-method-data {
    border-radius: 4px;
}

/* Styling for the add button (page 2) */
a.payment-method-add .icon {
    background: var(--finway-dark);
    color: var(--white-color);
}

/* Styling for the stepper for completed process */
.sub-steps .sub-step.pending {
    background-color: var(--finway-dark)
}
`
